<template>
    <div class="mr-4">
        <div class="pt-0 sticky sticky-top top-0 rounded-lg bg-gray-100 z-40" ref="header">
            <div class="relative cursor-pointer mt-0 mb-0 block">
                <div class="flex items-center justify-between px-3 py-1 text-left w-full">
                    <div class="flex w-full items-center">
                        <span v-if="(addingChannel || searchHandles.length || attachment)">
                              <span class="mx-0 text-xs text-gray-400 font-medium fa fa-plus"></span>
                        </span>
                        <svg
                            v-else
                            xmlns="http://www.w3.org/2000/svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="vue-feather text-gray-400 feather feather-search"
                        >
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                        <div class="ml-0 w-full">
                            <span v-for="handle in searchHandles"
                                  class="inline-block font-bold text-gray-500 text-xs border border-gray-200 whitespace-nowrap px-2 py-0.5 rounded my-0.5 ml-1.5"
                                  :class="handle.valid === true?'bg-blue-100':(handle.valid === false?'bg-red-100':'bg-white')"
                            >
                                <span v-text="handle.name"></span>
                                <span class="text-gray-400 fa fa-times pl-1 hover:text-blue-500"
                                      @click="removeHandle(handle)"></span>
                            </span>
                            <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg" ref="inlineSearch">
                                <template #default="{ open, close }">
                                    <div class="flex w-full items-center">
                                        <page-cell name="search"
                                                   v-model="search"
                                                   ref="searchBox"
                                                   @keydown.esc.stop="() => {if (!search && addingChannel){addingChannel=false;} else { if (search === ''){ closeSlide() } else { search = '';openInlineSearch(open, close)}}}"
                                                   @input="error = '';openInlineSearch(open, close)"
                                                   @focus="openInlineSearch(open,close)"
                                                   @keydown.enter="addHandle"
                                                   :placeholder="(addingChannel || searchHandles.length || attachment)?'Add recipient...':'Search...'"
                                                   :style="'box-shadow:none !important'"
                                                   class="mx-1 py-1.5 px-1.5 font-bold text-gray-600 border-none border-transparent resize-none outline-none shadow-none ring-0 bg-transparent text-sm mb-0 w-full">
                                        </page-cell>
                                        <span class="text-gray-500 fa fa-times pl-1 hover:text-blue-500"
                                              v-if="search || addingChannel"
                                              @click="addingChannel=false; search=''; openInlineSearch(open, close)"></span>
                                    </div>
                                </template>
                                <template #menu="{ close }">
                                    <div class="p-3 max-h-64 overflow-y-auto" v-if="search">
                                        <div v-for="channel in searchedChannels" v-if="channel.type !== 'GROUP'">
                                            <div
                                                class="relative group py-2 px-5 flex items-center hover:bg-gray-50 rounded-lg"
                                                @click="(e) => { addChannelToHandles(channel,e); close()}">
                                                <div class="flex-1 flex items-center min-w-0 relative">
                        <span class="flex-shrink-0 inline-block relative">
                            <message-widget-channel-avatars :contacts="contacts"
                                                            :channel="channel"></message-widget-channel-avatars>
                        </span>
                                                    <div class="ml-4 w-full truncate">
                                                        <div class="text-sm font-medium text-gray-900 flex w-full">
                                                            <div class="flex-grow truncate" v-text="channel.name"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </ui-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
            <div v-if="searchHandles.length || attachment || addingChannel"
                 class="mt-0 p-2 mb-0 block border-t border-gray-300">
                <div class="flex rounded-md"
                     v-if="(searchHandles.length > 1) || (searchHandles.length && search) || addingChannel">
                    <div class="relative flex items-center flex-grow focus-within:z-10 text-sm text-gray-400">
                        <label class="whitespace-nowrap my-0 ml-1 mr-0">Group name:</label>
                        <input name="group"
                               @focus="addHandle(false)"
                               v-model="newGroup"
                               @input="error=''"
                               placeholder="Enter a group name here..."
                               :style="'box-shadow:none !important; background:transparent !important; border:none !important; outline:none !important; outline-width:0 !important; margin:0px !important'"
                               class="m-0 py-1 font-bold border-none border-transparent resize-none text-brand outline-none shadow-none ring-0 bg-transparent text-sm w-full">
                    </div>
                </div>
                <div class="pt-1 flex rounded-md shadow-sm">
                    <div class="relative flex items-stretch flex-grow focus-within:z-10">
                        <autoresizable-textarea ref="autoresizable-textarea" @textarea:heightAdjusted="resetSticky">
                        <textarea
                            v-model="newMessage"
                            rows="2"
                            class="focus:ring-brand focus:border-brand block w-full mb-px rounded-none rounded-l-md pl-3 sm:text-sm border-gray-300"
                            placeholder="Enter message here..."
                            type="text"
                            @keydown.enter="sendFromEnter"
                            @input="()=> {error='';resetSticky()}"
                            @mouseup="resetSticky"
                            @mousedown="resetSticky"
                            @mousemove="resetSticky"
                            @focus="addHandle(false)"
                            :ref="'messagebox'"
                        ></textarea>
                        </autoresizable-textarea>
                    </div>
                    <button
                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand"
                        @click.prevent="sendMessage()"
                        :class="(this.sending || this.searchHandles.length === 0)?'text-gray-500 bg-gray-200 cursor-not-allowed':'text-gray-700 bg-gray-50 hover:bg-gray-100'"
                        :disabled="this.sending || this.searchHandles.length === 0"
                    >
                        <i class="fas fa-caret-right"></i>
                        <span>Send</span>
                    </button>
                </div>
                <div class="w-full text-gray-500 text-xs ml-1 mt-2.5 mb-1 cursor-default" v-if="attachment">
                    Attachment:
                    <a class="text-gray-500 hover:text-gray-500 border rounded border-gray-300 bg-gray-50 font-bold px-2 py-0.5 inline-block cursor-default ml-1 my-0.5"
                       :href="'#'">
                        <template v-if="attachment.type === 'DEFECT'">
                            <i class="fas fa-fragile mr-1"></i>
                            <span v-text="attachment.name"></span>
                        </template>
                    </a>
                </div>
            </div>
        </div>
        <div
            class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top z-20"
            :style="stickyTop">
            <div class="flex-grow">Chats</div>
            <div
                class="pl-l mt-1 border-gray-200 border rounded text-gray-500 hover:text-brand text-xs py-0.5 px-1.5 bg-white hover:bg-gray-50 font-medium cursor-pointer"
                @click="addChannel()">
                <span class="mx-px my-0.5 text-xs fa fa-plus"></span>
            </div>
        </div>
        <ul class="flex-1 divide-y divide-gray-200 overflow-none">
            <template v-if="searchedChannels.length">
                <li v-for="channel in searchedChannels">
                    <div class="relative group py-2 min-h-[90px] px-5 flex items-center">
                        <a class="-m-1 flex-1 block p-1 w-full" href="#"
                           @click.prevent="selectChannel(channel)"
                           @mouseover="hovering=channel"
                           @mouseleave="hovering=false">
                            <div aria-hidden="true" class="absolute inset-0 group-hover:bg-gray-50"
                                 :class="(selected && (selected === channel.source))?'bg-blue-50':'bg-white'"></div>
                            <div class="flex-1 flex items-center min-w-0 relative">
                        <span class="flex-shrink-0 inline-block relative">
                            <message-widget-channel-avatars :contacts="contacts"
                                                            :channel="channel"></message-widget-channel-avatars>
                        </span>
                                <div class="ml-4 w-full truncate">
                                    <div class="text-sm font-medium text-gray-900 flex w-full">
                                        <div class="flex-grow truncate">
                                            <span @mouseover="linkHovering=channel" class="flex-grow truncate"
                                                  @mouseleave="linkHovering=false">
                                                <span v-text="channel.name"></span>
                                                <span @click="(e) => addChannelToHandles(channel,e)"
                                                      :class="(linkHovering === channel) && (channel.type!=='GROUP')?'opacity-70':'opacity-0'"
                                                      class="transition-opacity duration-200 text-brand fa fa-plus pl-1 font-light text-xs"></span>
                                            </span>
                                            <p class="text-xs font-medium text-gray-500 flex-grow truncate"
                                               v-if="channel.type === 'DIRECT'"
                                               v-text="channel.members.find((i) => i.id === channel.source).knownHandles.filter((i) => i.trim()!=='').join(', ')"></p>
                                        </div>
                                        <div class="text-gray-500 mt-px items-end flex"
                                             v-text="dateToHuman(channel.lastMessageDateTime)"></div>
                                    </div>
                                    <div class="flex w-full truncate text-xs">
                                        <div class="flex-grow text-sm truncate">
                                            <template v-if="isTyping(channel)">
                                                <span class="text-xs font-semibold mr-0.5"
                                                      :class="channel.unseenReceivedCount > 0 ? 'text-brand font-bold' : 'text-gray-500'"
                                                      v-text="isTyping(channel)+' :'">
                                                </span><span class="animate-pulse-fade"
                                                             :class="channel.unseenReceivedCount > 0 ? 'text-brand' : 'text-gray-500'"
                                                             v-text="'is typing ...'"></span>
                                            </template>
                                            <template v-else-if="hasDraft(channel)">
                                                <span class="text-xs font-semibold text-yellow-500 mr-0.5"
                                                      v-text="'Draft :'">
                                                </span><span class="text-gray-500"
                                                             v-text="messageDrafts[channel.source].m"></span>
                                            </template>
                                            <template v-else>
                                                <div class="flex truncate items-baseline">
                                                    <span
                                                        class="text-xs font-semibold mr-0.5"
                                                        v-text="getWho(channel)"
                                                        :class="channel.unseenReceivedCount > 0 ? 'text-brand font-bold' : 'text-gray-500'">
                                                    </span>
                                                    <span class="truncate" v-text="channel.messages.slice(-1)[0].text"
                                                          :class="channel.unseenReceivedCount > 0 ? 'text-brand' : 'text-gray-500'">
                                                    </span>
                                                    <span v-if="(getWho(channel)!=='') && lastMessageViewed(channel)"
                                                          class="text-green-400 ml-1.5"><i class="fa fa-check"
                                                                                           style="font-size:9px"/></span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span
                                v-if="channel.unseenReceivedCount"
                                class="absolute top-1.5 right-2 text-center px-0 py-0.5 w-5 h-5 rounded-full text-xs font-medium bg-red-500 text-white"
                                v-text="channel.unseenReceivedCount"></span>
                        </a>
                    </div>
                </li>
            </template>
        </ul>
        <template v-if="searchedContacts.length">
            <div
                class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top z-20"
                :style="stickyTop">
                <span>Contacts</span>
            </div>
            <ul class="flex-1 divide-y divide-gray-200 overflow-none">
                <li v-for="contact in searchedContacts">
                    <div class="relative group min-h-[90px] px-5 flex items-center">
                        <a class="-m-1 flex-1 block p-1 w-full" href="#"
                           @click.prevent="selectChannel({avatarUrl:contact.avatarUrl}, contact.name, contact.id)"
                           @mouseover="hovering=contact"
                           @mouseleave="hovering=false">
                            <div aria-hidden="true" class="absolute inset-0 group-hover:bg-gray-50"
                                 :class="(selected && (selected === contact.id))?'bg-blue-50':'bg-white'"></div>
                            <div class="flex-1 flex items-center min-w-0 relative">
                        <span class="flex-shrink-0 my-5 inline-block relative">
                            <message-widget-channel-avatars :contacts="contacts"
                                                            :channel="{type:'DIRECT',avatarUrl:contact.avatarUrl,source:contact.id,name:contact.name}"></message-widget-channel-avatars>
                        </span>
                                <div class="ml-4 truncate">
                                    <p class="text-sm font-medium text-gray-900 truncate">
                                        <span @mouseover="linkHovering=contact"
                                              @mouseleave="linkHovering=false"
                                        >
                                        <span v-text="contact.name"></span>
                                        <span :class="(linkHovering === contact)?'opacity-70':'opacity-0'"
                                              @click.stop="addContactToHandles(contact)"
                                              class="transition-opacity duration-200 text-brand fa fa-plus pl-1 font-light text-xs"></span>
                                        </span>
                                    </p>
                                    <p class="text-sm truncate" v-if="messageDrafts[contact.id]">
                                        <span class="text-xs font-semibold text-yellow-500" v-text="'Draft :'"></span>
                                        <span class="text-gray-500" v-text="messageDrafts[contact.id].m"></span>
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </li>
            </ul>
        </template>
        <template v-if="searchedMessages.length">
            <div
                class="pl-1 border-b border-gray-200 text-brand bg-white font-semibold text-lg h-14 flex items-center sticky sticky-top top-12 z-20"
                :style="stickyTop">
                <span>Messages</span>
            </div>
            <ul class="flex-1 divide-y divide-gray-200 overflow-none">
                <li v-for="channel in searchedMessages">
                    <div class="relative group px-5 flex items-center">
                        <a class="-m-1 flex-1 block p-1 w-full" href="#"
                           @mouseover="hovering=channel"
                           @mouseleave="hovering=false"
                           @click.prevent="selectChannel(channel)">
                            <div aria-hidden="true" class="absolute inset-0 group-hover:bg-gray-50 bg-white"></div>
                            <div class="flex-1 flex my-2 min-w-0 relative">
                        <span class="flex-shrink-0 my-5 inline-block relative">
                            <message-widget-channel-avatars :contacts="contacts"
                                                            :channel="channel"></message-widget-channel-avatars>
                        </span>
                                <div class="flex ml-4 items-center truncate w-full">
                                    <div class="flex-1 truncate w-full">
                                        <p class="text-sm font-medium text-gray-900 truncate mt-0">
                                            <span @mouseover="linkHovering=channel"
                                                  @mouseleave="linkHovering=false">
                                                <span v-text="channel.name"></span>
                                                <span @click="(e) => addChannelToHandles(channel,e)"
                                                      :class="(linkHovering === channel) && (channel.type!=='GROUP')?'opacity-70':'opacity-0'"
                                                      class="transition-opacity duration-200 text-brand fa fa-plus pl-1 font-light text-xs"></span>
                                            </span>
                                        </p>
                                        <p class="text-xs font-medium text-gray-500 truncate my-0 pl-1 py-0.5 hover:bg-white hover:border-gray-200 border border-transparent rounded-lg w-full"
                                           v-for="message in channel.messages"
                                           @click.stop="selectChannel(channel,null,null, message.id)"
                                        ><span class="font-semibold text-brand"><i class="fas"
                                                                                   :class="message.who === user.id?'fa-arrow-right':'fa-arrow-left'"></i></span><span
                                            class="ml-1"
                                            v-html="highlight(message.text)"></span></p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>

import moment from "moment-timezone";
import PageCell from "../../ui/PageCell.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {cloneDeep} from "lodash";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import {Message} from "@models";
import {uuid} from "../../../utils";
import UiInput from "../../ui/UiInput.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import MessageWidgetChannelAvatars from "./MessageWidgetChannelAvatars.vue";
import remoteStorage from "../../../utils/remoteStorage";
import User from "../../../services/User";

export default {
    components: {MessageWidgetChannelAvatars, UiDropdown, UiInput, AutoresizableTextarea, UiButtonNew, PageCell},
    props: {
        user: Object,
        channels: [],
        contacts: [],
        attachment: null,
        selected: null,
    },
    data() {
        return {
            search: '',
            newGroup: '',
            newMessage: '',
            searchHandles: [],
            moment,
            hovering: false,
            linkHovering: false,
            stickyTop: '',
            error: false,
            sending: false,
            messageDrafts: remoteStorage.getItem('messageDrafts', {}, true),
            addingChannel: false,
        }
    },
    computed: {
        searchedChannels() {
            const query = this.search.trim().toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ch = this.channels.slice()
            if (query.length) {
                ch = ch.filter((c) => {
                    return query.every((token) => {
                        return c.tokens.includes(token);
                    })
                });
            }
            Object.entries(this.messageDrafts).sort((a, b) => moment(a[1].d).diff(moment(b[1].d))).forEach(([id, m]) => {
                let channel = ch.find((i) => i.source === id);
                if (channel && (moment(m.d) > moment(channel.lastMessageDateTime))) {
                    ch.splice(ch.indexOf(channel), 1)
                    ch.unshift(channel)
                }
            })
            return ch
        },
        searchedContacts() {
            let base = this.contacts.filter((i) => !this.channels.some((c) => (c.type === 'DIRECT') && (c.source === i.id)));
            const query = this.search.trim().toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return base.filter((c) => {
                    return query.every((token) => {
                        return c.tokens.includes(token);
                    })
                });
            }
            return base
        },
        searchedMessages() {
            let channels = [];
            const query = this.search.trim().toLowerCase();
            if (query.length) {
                cloneDeep(this.channels).forEach((channel) => {
                    let messages = [];
                    channel.messages.forEach((message) => {
                        if (message.tokens.includes(query)) {
                            messages.push(message);
                        }
                    })
                    channel.count = messages.count;
                    channel.messages = messages.slice(0, 10)
                    if (messages.length) {
                        channels.push(channel)
                    }
                })
            }
            // limit to at most 25 channels
            return channels.slice(0, 15)
        },
        unread() {
            return 0
        },
    },
    methods: {
        addChannel() {
            this.addingChannel = true
            this.$nextTick(() => {
                this.focusOnSearch()
            })
        },
        dateToHuman(dateTime) {
            let m = moment(dateTime).locale('en-gb');
            let now = moment();
            if (now.diff(m, "days") >= 7) {
                return m.format('L')
            } else {
                if ((now.diff(m, "days") === 0) && (now.day() === m.day())) {
                    return m.format('HH:mm')
                }
            }
            return m.format('dddd')
        },
        closeSlide() {
            this.$emit('close', false);
        },
        isTyping(channel) {
            let c = this.channels.find((i) => i.id === channel.id)
            if (c && c.lastTyping) {
                let who = c.lastTyping.filter((i) => {
                    return i.who !== this.user.id && (moment().diff(moment(i.when), 'seconds') < 4)
                })
                if (who.length) {
                    let re = who.map((last) => {
                        let who = channel.members.find((i) => i.id === last.who);
                        return who ? who.name : '';
                    }).filter((i) => i.trim() !== '')
                    return (re.length === 2) ? re.join(' & ') : re.join(', ');
                }
            }
            return false
        },
        hasDraft(channel) {
            let draft = this.messageDrafts[channel.source]
            return (draft && (moment(draft.d) > moment(channel.lastMessageDateTime)))
        },
        lastMessageViewed(channel) {
            return channel.lastMessageWasViewed
        },
        getWho(channel) {
            if (channel.messages.length) {
                let lastMessage = channel.messages.slice(-1)[0];
                if (!lastMessage.who) {
                    return '';
                } else if (lastMessage.who === this.user.id) {
                    return 'You :'
                } else {
                    let member = channel.members.find((i) => i.id === lastMessage.who)
                    if (member) {
                        return member.name + ' :'
                    }
                }
            }
            return ''
        },
        addHandle(focus = true) {
            if (this.search) {
                if (!this.searchHandles.some((i) => i.name === this.search)) {
                    let handle = {
                        'name': this.search,
                        'source': this.search,
                        'valid': null
                    }
                    this.searchHandles.push(handle)
                    Message.checkHandle(handle.source).then((r) => {
                        handle.valid = r.valid
                    })
                    this.resetSticky();
                }

                this.search = '';
                this.error = '';
                if (focus) {
                    this.$refs.searchBox.$el.focus();
                }
            }
        },
        removeHandle(handle) {
            this.searchHandles = this.searchHandles.filter((i) => i !== handle)
            this.error = '';
            this.resetSticky();
        },
        addChannelToHandles(channel, e) {
            if ((channel.type !== 'GROUP') && (!this.searchHandles.some((i) => i.name === channel.name))) {
                this.error = '';
                e.stopPropagation();
                this.searchHandles.push({'name': channel.name, 'source': channel.source})
                this.search = '';
                this.resetSticky();
                this.$refs.searchBox.$el.focus();
            }
        },
        openInlineSearch(open, close) {
            if (this.search && this.searchedChannels.filter((i) => i.type !== 'GROUP').length && (this.addingChannel || this.searchHandles.length || this.attachment)) {
                if (!this.$refs.inlineSearch.opened) {
                    open();
                }
                return
            }
            close();
        },
        addContactToHandles(contact) {
            if (!this.searchHandles.some((i) => i.source === contact.id)) {
                this.error = '';
                this.searchHandles.push({'name': contact.name, 'source': contact.id})
                this.search = '';
                this.resetSticky();
                this.$refs.searchBox.$el.focus();
            }
        },
        highlight(text) {
            let target = 40;
            // find first match
            let q = this.search.trim()
            let position = Math.min(text.length - (target - q.length), text.toLowerCase().indexOf(q.toLowerCase()) - ((Math.max(target - q.length, 0)) / 2))
            // round to nearest space
            let before = position, settle = false;
            do {
                before--
                if ((text.substring(before, before + 1) === ' ') || (before <= 0)) {
                    settle = before;
                }
            } while (settle === false)
            let s = text.substring(Math.max(0, settle));
            return s.replace(new RegExp(q.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'ig'), '<span class="font-semibold text-brand whitespace-pre">' + '$&' + '</span>')
        },
        sendFromEnter(e) {
            if (!e.ctrlKey && !e.shiftKey && !e.metaKey && !e.altKey) {
                e.preventDefault()
                this.sendMessage()
            }
        },
        async sendMessage() {
            let returnSourceId, response;
            this.error = '';
            if (this.searchHandles.length === 1) {
                // direct message
                response = await Message.send(this.searchHandles[0], this.newMessage, uuid(), null, this.attachment ? [this.attachment] : [])
                returnSourceId = this.searchHandles[0].source;
            } else if (this.searchHandles.length > 1) {
                returnSourceId = uuid()
                response = await Message.sendGroup(returnSourceId, this.searchHandles.map((i) => i.source), this.newMessage, uuid(), this.newGroup, this.attachment ? [this.attachment] : [])
            }
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Handle type cannot be detected from')) {
                    let problem = (response.data.message + ' ').split('"')
                    problem = problem.slice(1, -1).join('"');
                    this.error = 'ERROR: Cannot determine how to handle "' + problem + '" - is this a valid email address or phone number?'
                    this.resetSticky()
                    return
                }
            }
            this.searchHandles = [];
            this.search = ''
            this.newMessage = ''
            this.$emit('updateMessages', returnSourceId)
        },
        focusOnSearch() {
            if (this.$refs.searchBox) {
                this.$refs.searchBox.$el.focus()
                if (this.search) {
                    let inSea = this.search
                    this.search = '';
                    this.$nextTick(() => {
                        this.search = inSea
                        this.$refs.inlineSearch.open()
                    })
                }
            }
        },
        selectChannel(channel, name, source, messageId) {
            this.$emit('channelSelected', channel, name, source, messageId)
        },
        resetSticky() {
            if (this.$refs.header) {
                this.$nextTick(() => {
                    this.stickyTop = 'top: ' + (this.$refs.header.getBoundingClientRect().height) + 'px;'
                    this.$nextTick(() => {
                        if (this.$refs.header) {
                            this.stickyTop = 'top: ' + (this.$refs.header.getBoundingClientRect().height) + 'px;'
                        }
                    })
                })
            } else {
                setTimeout(() => {
                    this.resetSticky()
                }, 50)
            }
        },
        updateUserFromListener(event) {
            if (event.aggregate.data.remoteStorage) {
                this.messageDrafts = JSON.parse(event.aggregate.data.remoteStorage.messageDrafts);
            }
        },
    },
    mounted() {
        User.registerAggregate({"type": 'User', 'id': this.user.id}, this.updateUserFromListener)
        this.newMessage = this.attachment ? this.attachment.message : ''
        this.resetSticky();
    },
    beforeUpdate() {
        this.resetSticky();
    }
}
</script>
